import { Card, Table } from '@quero-delivery/quero-components-web';

import {
  subYears,
  getEndOfDay,
  getStartOfDay,
} from '@querodelivery/qd-date-helper';
import isEmpty from 'lodash/isEmpty';
import { ButtonSeeAllList } from '@/_features/motoboys/motoboy-details/components/button-see-all-list';

import styles from './extract-list.module.scss';
import { useGetExtractsPlaces } from '@/_features/places/api/get-extracts-place';
import { ExtractRow } from '../extract-row';

interface IProps {
  title?: string;
  label?: string;
  hasMore?: () => void;
  limitShownExtracts?: number;
  startDate?: Date;
  endDate?: Date;
  id: string;
}

const defaultTitle = 'Extratos';
const defaultLabel = 'extrato';

function ExtractsList({
  id,
  title = defaultTitle,
  label = defaultLabel,
  hasMore,
  limitShownExtracts = 3,
  startDate,
  endDate,
}: IProps) {
  const startDateISO = getStartOfDay(
    startDate || subYears(new Date(), 10),
  ).toISOString();

  const endDateISO = getEndOfDay(endDate || new Date()).toISOString();

  const { data: extractsData, isLoading: isLoadingExtracts } =
    useGetExtractsPlaces(
      {
        placeId: id,
        limit: limitShownExtracts,
        startDate: startDateISO,
        endDate: endDateISO,
      },
      {
        enabled: !!id,
      },
    );

  const extracts = extractsData?.results;
  const totalCount = extractsData?.total_count;

  if (!extracts || isEmpty(extracts)) {
    return (
      <>
        <Table title={title} compact textAlign="center" />
        <p className="text-center">Nenhum extrato encontrado</p>
      </>
    );
  }

  const hasMoreExtracts =
    limitShownExtracts && totalCount && totalCount > limitShownExtracts;

  return (
    <Card type="min-shadow" className={styles.card} loading={isLoadingExtracts}>
      <div className={styles.containerLabel}>
        <span>Últimas transações</span>
        <span>
          {label
            ? `${totalCount} ${totalCount === 1 ? label : `${label}s`}`
            : undefined}
        </span>
      </div>
      <div className={styles.containerTable}>
        <Table compact textAlign="left">
          <>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Data</Table.HeaderCell>
                <Table.HeaderCell>Valor</Table.HeaderCell>
                <Table.HeaderCell>Operação</Table.HeaderCell>
                <Table.HeaderCell>Motivos</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {extracts.map(extract => (
                <ExtractRow key={extract._id} extract={extract} />
              ))}
            </Table.Body>
          </>
        </Table>
      </div>
      {hasMoreExtracts ? (
        <ButtonSeeAllList onClick={hasMore || undefined} />
      ) : null}
    </Card>
  );
}

export { ExtractsList };
